import { useState } from "react";
import Api from "../../services/ApiService";
import { Row, Col, Form, FloatingLabel, Spinner, Button } from "react-bootstrap";

const PasswordComponent = () => {

    const API = new Api();
    const [email, setEmail] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState("");
    const [view, setView] = useState("default");


    const submitHandler = (e) => {
        e.preventDefault();
        setError("");
        setIsLoading(true);

        API.access_request_pass_change({email: email})
            .then(res => {
                if (res.data.hv === true) setView("hw");
                else setView("done");
                setIsLoading(false);
            })
            .catch(err => {
                setIsLoading(false);
                if (err.response.data.detail !== undefined) {
                    setError(err.response.data.detail);
                } else {
                    setError("Unbekannter Fehler. Versuchen Sie später noch mal.")
                }
            })
    }


    return (
        <div className="actions-section-content">
            <Row>
                <Col xs="12" className="animate-pop text-light">
                    <h3 className="text-light"><span className="text-dark title-energo">ENERGO </span>Passwort anfordern / vergessen</h3>
                </Col>
            </Row>
            {
                view === "default" ?
                    <Row className="mt-5">
                        <Form onSubmit={e => submitHandler(e)}>
                            <p className="text-light">Geben Sie bitte Ihre E-Mail-Adresse ein, um Ihr Passwort anzufordern/zurückzusetzen.</p>
                            <Form.Group className="mb-3">
                                <FloatingLabel label="E-Mail-Adresse">
                                    <Form.Control
                                        type="email"
                                        autoComplete="email"
                                        value={email}
                                        onChange={e => setEmail(e.target.value)}
                                        placeholder="E-Mail-Adresse"
                                    />
                                </FloatingLabel>
                                <Form.Text className="text-danger">
                                    {error}
                                </Form.Text>
                            </Form.Group>
                            <div className="text-center">
                                {
                                    isLoading ? 
                                        <Spinner animation="border" variant="warning" /> :
                                        <Button variant="warning" type="submit">Absenden</Button>
                                }
                            </div>
                        </Form>
                    </Row> :
                
                view === "hw" ?
                    <Row className="mt-5">
                        <Col className="animate-pop">
                            <p style={{fontWeight: 600}}>
                                Zurücksetzen / Anfordern des Passworts ist für Hausverwaltungen nicht möglich.
                                Bitte wenden Sie sich an Ihr Sekretariat, um das Passwort in Erfahrung
                                zu bringen.
                            </p>
                        </Col>
                    </Row> :

                view === "done" ? 
                    <Row className="mt-5">
                        <Col className="animate-pop">
                            <p style={{fontWeight: 600}}>
                                Wir haben Ihnen eine E-Mail zukommen lassen!
                                Folgen Sie bitte den Schritten in der E-Mail.
                            </p>
                        </Col>
                    </Row> :
                null
            }
        </div>
    )
}
export default PasswordComponent;